import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';
import { CRQAnswers, CRQuestion } from 'views/App/Portal/Policy/_types/crq';

export default function useManageCRQ() {
  const answers = async (
    manualId: string,
    data: CRQAnswers,
    callback?: () => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexiverse/manual-crq/v1/manuals/${manualId}/answers`;
    await fetcher({
      url,
      method: 'put',
      body: data,
    })
      .then(() => {
        if (callback) callback();
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  const create = async (
    manualId: string,
    data: CRQuestion,
    callback?: (data: CRQuestion) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexiverse/manual-crq/v1/manuals/${manualId}/questions`;
    await fetcher({
      url,
      method: 'post',
      body: data,
    })
      .then((data) => {
        if (callback) callback(data);
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  const update = async (
    manualId: string,
    questionId: string,
    data: CRQuestion,
    callback?: (data: CRQuestion) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexiverse/manual-crq/v1/manuals/${manualId}/questions/${questionId}`;
    await fetcher({
      url,
      method: 'put',
      body: data,
    })
      .then((data) => {
        if (callback) callback(data);
      })
      .catch((err) => {
        console.warn('update err', err);
        if (onError) handleError(err, { onError });
      });
  };

  const destroy = async (
    manualId: string,
    questionId: string,
    callback?: () => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexiverse/manual-crq/v1/manuals/${manualId}/questions/${questionId}`;
    await fetcher({
      url,
      method: 'delete',
      body: {},
    })
      .then(() => {
        if (callback) callback();
      })
      .catch((err) => {
        console.warn('update err', err);
        if (onError) handleError(err, { onError });
      });
  };

  return {
    answers,
    create,
    destroy,
    update,
  };
}
